import axios from "axios";
import { apiUrl } from "./api";

const api = axios.create({
  baseURL: apiUrl,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

export const CheckClientVerify = async (addUrl) => {
  return await api.get(`client/verify?${addUrl}`);
};
